import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';

import { catchError, first } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  SendRequestService,
  syncInject,
  SyncNg,
  ApiStore,
} from 'sync-engine';
import { Setting } from 'src/setting';

@Injectable()
export class HttpClientService extends SendRequestService {
  onResponse: Subject<any> = new Subject();
  @syncInject()
  declare syncNg: SyncNg;

  constructor(private _http: HttpClient) {
    super();
  }

  sendRequest<ResponseData>(store: ApiStore<ResponseData>): void {
    // To Do
    const apiStructure = JSON.parse(store.apiStructure);
    const url = this.combineUrl(apiStructure.route);
    const headers = this.castHeaders(apiStructure?.options?.headers);
    let responseObserve = <Observable<any>>null;
    if (apiStructure.method === 'get') {
      responseObserve = this.get(url, headers);
    } else if (apiStructure.method === 'post') {
      responseObserve = this.post(url, store.body, headers);
    } else if (apiStructure.method === 'delete') {
      responseObserve = this.delete(url, headers);
    } else if (apiStructure.method === 'put') {
      responseObserve = this.put(url, store.body, headers);
    }
    responseObserve.pipe(first()).subscribe((paresResponse) => {
      this.onResponse.next(paresResponse);
      store.responseResult$.next({
        update: store.responseResult$.getValue().update,
        onload: false,
        response: paresResponse as ResponseData,
      });
    });
  }

  post<BodyData>(url: string, data: BodyData, headers?: HttpHeaders) {
    return this._http
      .post(url, data, { headers: headers })
      .pipe(catchError((err) => of(err)));
  }

  put<BodyData>(url: string, data: BodyData, headers?: HttpHeaders) {
    return this._http
      .put(url, data, { headers: headers })
      .pipe(catchError((err) => of(err)));
  }

  delete(url: string, headers?: HttpHeaders) {
    return this._http
      .delete(url, { headers: headers })
      .pipe(catchError((err) => of(err)));
  }

  get(url: string, headers?: HttpHeaders) {
    return this._http
      .get(url, { headers: headers })
      .pipe(catchError((err) => of(err)));
  }

  castHeaders(headers: { [key: string]: string }): HttpHeaders {
    let OrginalHeader: HttpHeaders = new HttpHeaders();
    for (const key in headers) {
      const value = headers[key];
      OrginalHeader = OrginalHeader.append(key, value);
    }

    return OrginalHeader;
  }

  combineUrl(route: string): string {
    const url = route.replace(/null/g, '');

    let fullUrl: string;

    if (Setting.getOrigin) {
      fullUrl = '' + url;
    } else {
      fullUrl = url;
    }

    return fullUrl;
  }
}
